import { HeaderText, Separator } from "@/components/ui";

export const SectionHeader = ({
  title,
  titleBadge,
  actionButtons,
  showSeparator = true,
}: {
  title: string;
  /**
   * Optional small element rendered to the right of the title — typically a
   * count pill / badge (e.g. "3 suggested"). Kept generic so each section
   * can render its own variant.
   */
  titleBadge?: React.ReactNode;
  actionButtons?: React.ReactNode[];
  showSeparator?: boolean;
}) => {
  return (
    <>
      <div className="flex flex-row items-center justify-between align-middle mb-2 min-h-6">
        <div className="flex flex-row items-center gap-2">
          <HeaderText size="md">{title}</HeaderText>
          {titleBadge}
        </div>
        <div className="flex flex-row gap-3">{actionButtons}</div>
      </div>
      {showSeparator && <Separator />}
    </>
  );
};

export const SectionSubheader = ({
  title,
  iconComponent,
}: {
  title: string;
  iconComponent: React.ElementType;
}) => {
  const Icon = iconComponent;
  return (
    <div className="flex flex-row items-center gap-2 h-10 bg-secondary p-3">
      <Icon className="h-4 w-4" />
      <HeaderText tag="h3" size="md" className="mt-0.5">
        {title}
      </HeaderText>
    </div>
  );
};
